import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/pro-regular-svg-icons';
import { DialogContent, Grid, Typography } from '@mui/material';
import { translate } from 'utils';
import { SelectLanguage } from 'components';
import { i18nStore } from 'stores';
import { HeaderModal } from './_HeaderModal';
import { CustomActionButtons } from './_CustomActionButtons';

export const ChangeLanguageModal = ({
  onConfirm, onClose, defaultValues
}) => {
  const [language, setLanguage] = useState(null);
  const { languageList } = i18nStore;

  useEffect(() => {
    if (languageList.length > 0 && defaultValues) {
      setLanguage(languageList.find(lg => lg.value.toUpperCase().indexOf(defaultValues.toUpperCase()) !== -1));
    }
  }, [languageList, defaultValues]);

  const handleSelectLanguage = useCallback(value => setLanguage(value), []);

  const handleValidateModal = useCallback(e => {
    e.preventDefault();

    onConfirm(language);
    onClose();
  }, [onClose, onConfirm, language]);

  return (
    <form onSubmit={handleValidateModal}>
      <HeaderModal onClose={onClose}>
        <FontAwesomeIcon icon={faGlobe} />
        <Typography component="span">
          {translate('modalChangeLanguage.title')}
        </Typography>
      </HeaderModal>

      <DialogContent style={{ paddingTop: '10px' }}>
        <Grid container direction="column">
          <SelectLanguage
            languages={languageList}
            required
            value={language}
            onChange={handleSelectLanguage}
          />
        </Grid>
      </DialogContent>

      <CustomActionButtons
        isValidated={defaultValues.validated}
        onClose={onClose}
      />
    </form>
  );
};

ChangeLanguageModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  defaultValues: PropTypes.string
};

ChangeLanguageModal.defaultProps = {
  defaultValues: {}
};
